import { MessagingProvider } from '@src/model/frontendmodel';
import { activeChatSelector } from '@src/selectors/chats';
import { ChatTray } from '@src/types/chats';
import { useSelector } from 'react-redux';

const useProvider = (): MessagingProvider => {
  const activeChat = useSelector(activeChatSelector) as ChatTray;

  return activeChat?.provider;
};

export default useProvider;
